import { makeStyles, shorthands } from '@fluentui/react-components';
import { isMobile } from 'react-device-detect';

import { customTokens } from 'src/utils/theme';

export const usePromoBannerStyles = makeStyles({
  actionElement: {
    textAlign: 'center',
    width: '100%',
    lineHeight: '1.5',
    backgroundColor: customTokens.colorNeutralCardBackground2,
    border: 'none',
    ...shorthands.padding(customTokens.spacingVerticalL, customTokens.spacingHorizontalXXXL),
  },
  wrapper: {
    padding: '0',
    borderRadius: isMobile ? undefined : '50px',
    ...shorthands.border(customTokens.strokeWidthThin, 'solid', customTokens.colorNeutralStencil2),
  },
  headline: {
    color: customTokens.colorNeutralForeground5,
    fontSize: customTokens.fontSizeBase600,
    fontWeight: customTokens.fontWeightBold,
    margin: '0',
  },
  subHeadline: {
    color: customTokens.colorNeutralForeground1,
    fontSize: customTokens.fontSizeBase400,
    fontWeight: customTokens.fontWeightRegular,
    margin: '0',
  },
});
